"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _constantVariants = require("./constantVariants");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SNETButton = _ref => {
  let {
    color,
    variant,
    ...rest
  } = _ref;
  const styleKey = () => {
    return `${color}-${variant ?? ""}`;
  };
  const buttonStyles = () => {
    return _constantVariants.buttonStyleVariants[styleKey()];
  };
  const classes = (0, _styles.useStyles)(buttonStyles());
  if (_constantVariants.muiButtonColors[color]) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      className: classes.root,
      color: _constantVariants.muiButtonColors[color],
      variant: variant
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, _extends({
    className: classes.root,
    color: color,
    variant: variant
  }, rest));
};
var _default = exports.default = SNETButton;